import { NgModule } from '@angular/core';
import { RuiPageModule } from '@sfey/ui/page';
import { BreadcrumbsDirective } from './breadcrumbs.directive';

@NgModule({
    declarations: [BreadcrumbsDirective],
    exports: [BreadcrumbsDirective],
    imports: [RuiPageModule],
})
export class BreadcrumbsModule {}
